const modal = {
    init: () => {
        const modal = document.querySelector('.modal');

        if ( modal ) {
            const trigger = document.querySelector('.modal__trigger');
            const videoContainer = document.querySelector('.modal__video-container');
            const close = document.querySelector('.modal__close');
            const video = document.querySelector('.modal__video');
            
            videoContainer.style.transition = 'all 0.3s';
    
            // Functions
    
            const openVideo = () => {
                videoContainer.classList.add('modal__video-container--active');
                video.play();
            }
    
            const closeVideo = () => {
                videoContainer.classList.remove('modal__video-container--active');
                video.pause();
            }
    
            // Triggers
    
            trigger.addEventListener('click', (e) => {
                openVideo();
            });
    
            close.addEventListener('click', () => {
                closeVideo();
            });
    
            videoContainer.addEventListener('click', (e) => {
                if (e.target != video) {
                    closeVideo();
                }
            });
            
        }
    }
}

export default modal;